import { X } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { Href, MyStatus, StatusUpdate } from "../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeLeftSide } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { dynamicImage, Image } from "../../../../../Utils";
import ContactStatus from "./ContactStatus";

const Status = () => {
  const dispatch = useAppDispatch();
  return (
    <Fragment>
      <div className="my-status-box">
        <div className="status-content">
          <div className="d-flex">
            <div className="img-status">
              <div className="user-status two">
                <Image className="img-fluid bg-img" src={dynamicImage("avtar/girls.jpg")} alt="status" />
              </div>
              <div className="upload-img">
                <input type="file" />
              </div>
            </div>
            <div className="flex-grow-1">
              <h3>{MyStatus}</h3>
              <p>{StatusUpdate}</p>
            </div>
            <div>
              <a className="icon-btn btn-outline-light btn-sm close-panel" href={Href} onClick={() => dispatch(closeLeftSide())}><X /></a>
            </div>
          </div>
        </div>
      </div>
      <ContactStatus />
    </Fragment>
  );
};

export default Status;
